module.exports = __webpack_public_path__ + "img/categorie-accesoires-famille-boutrais-small.40e8dfad.jpg";